/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { UserModel } from "../../../../app/modules/auth/models/UserModel";
import { RootState } from "../../../../setup";
// import {Languages} from './Languages'
import * as auth from "../../../../app/modules/auth/redux/AuthRedux";
import { useDispatch } from "react-redux";
import { toAbsoluteUrl } from "../../../helpers";
// import profileAPI from "../../../../api/profile/profileAPI";
import { toast } from "react-toastify";
import { isObject } from "../../../../app/utility/common-validation";

const HeaderUserMenu: FC = () => {

  const user: any = useSelector<RootState>(
    ({ auth }) => auth.user,
    shallowEqual
  );

  const dispatch = useDispatch();
  const logout = () => {
    dispatch(auth.actions.logout());
  }       ;

  //  const loginUserInfo =
  //      isObject(user?.data) && isObject(user.data.role) ? user.data.role : {};


  return (
    <div
      className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px"
      data-kt-menu="true"
    >
      <div className="menu-item px-3">
        <div className="menu-content d-flex align-items-center px-3">
          <div className="symbol symbol-60px me-5">
            {/* <img alt="Logo" src={toAbsoluteUrl("/media/avatars/blank.png")} /> */}
            <img alt="Logo" src={`${user?.data?.imageFolderPath}/${user?.data?.profile_image}`} onError={(e:any) => {
              e.target.onerror = null; // prevents infinite loop
              e.target.src = toAbsoluteUrl("/media/avatars/blank.png")  // fallback image path (public folder)
            }} />

          </div>

          {/* <div className="d-flex flex-column">
            <div className="fw-bolder d-flex align-items-center fs-5">
              {user.first_name} {user.first_name}
              
            </div>
            <a href="#" className="fw-bold text-muted text-hover-primary fs-7">
              {user.email}
            </a>
          </div> */}
        </div>
      </div>

      <div className="separator my-2"></div>

      <div className="menu-item px-5">
        <p className="m-0 fs-4 fw-semibold">
          {user?.data?.name || ""}

        </p>
      </div>

      {/* <div className='menu-item px-5'>
        <a href='#' className='menu-link px-5'>
          <span className='menu-text'>My Projects</span>
          <span className='menu-badge'>
            <span className='badge badge-light-danger badge-circle fw-bolder fs-7'>3</span>
          </span>
        </a>
      </div> */}

      <div
        className="menu-item px-5"
        data-kt-menu-trigger="hover"
        data-kt-menu-placement="left-start"
        data-kt-menu-flip="bottom"
      ></div>

      <div className="separator my-2"></div>

      {/* <Languages /> */}

      <div className="menu-item px-5 mb-1">
        <Link to="/profile" className="menu-link px-5">
          Profile
        </Link>
      </div>

      <div className="menu-item px-5 mb-1">
        <Link to="/change-password" className="menu-link px-5">
          Change Password
        </Link>
      </div>

      <div className="menu-item px-5">
        <a onClick={logout} className="menu-link px-5">
          Sign Out
        </a>
      </div>
    </div>
  );
};

export { HeaderUserMenu };
